import { InnerUserContext } from "./InnerUserContext";

import { useState } from "react";
import { useUserQuery } from "../../hooks/useUserQuery";

export default function UserContext({
  children,
}: {
  children: React.ReactNode;
}) {
  const [chatLoaded, setChatLoaded] = useState(false);

  const { data: user, isLoading } = useUserQuery();

  return (
    <InnerUserContext.Provider
      value={{ user, isLoading, chatLoaded, setChatLoaded }}
    >
      {children}
    </InnerUserContext.Provider>
  );
}
